import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
// import * as AiIcons from "react-icons/ai";
import { SidebarData } from "./SidebarData";
import SubMenu from "./SubMenu";
import Logo from '../../../assets/Admin_Portal/images/dashboard_logo.png'
import { Col, Row, Form, FloatingLabel, Table, InputGroup, Button } from "react-bootstrap";

const SidebarLogo = styled.div`
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #343434;
  `

// const NavIcon = styled(Link)`
//   margin-left: 16rem;
//   font-size: 2rem;
//   height: auto;
//   display: flex;
//   justify-content: flex-start;
//   align-items: center;
// `;

const SidebarNav = styled.nav`
  background: #f7f8fb;
  width: 300px;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 0;
  left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
  transition: 350ms;
  z-index: 10;
`;

const SidebarWrap = styled.div`
  width: 100%;
  background: #27153f;
`;


const NavButtonList = styled.div`
  height: calc(100vh - 180px);
  overflow: auto;
  margin-bottom: 20px;
`;
const SidebarListing = () => {
  const [sidebar, setSidebar] = useState(true);
  const showSidebar = () => setSidebar(!sidebar);

  return (
    <>
      {/* <IconContext.Provider value={{ color: "#fff" }}> */}
      
          <SidebarNav sidebar={sidebar}>
            <SidebarWrap>
              <SidebarLogo>
                <img src={Logo} alt="" />
              </SidebarLogo>
           
              <NavButtonList>


                {SidebarData.map((item, index) => {
                  return <SubMenu item={item} key={index} />
                })}
              </NavButtonList>
            </SidebarWrap>
          </SidebarNav>


      {/* </IconContext.Provider> */}
    </>
  );
}

export default SidebarListing
